/*
PROV: COHINT001.BF.ZP3UKJHIXA
REQ: SYS-ARCH-15
WHY: Frontend component module.
*/

import React from "react";
import { logger } from "../lib/logger";
import { getLastApiContext } from "@cohorta/shared/api/client";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const message = error instanceof Error ? error.message : String(error);
    const stack = error instanceof Error ? error.stack : undefined;
    const componentStack = errorInfo?.componentStack ? String(errorInfo.componentStack) : "";
    const last = getLastApiContext();
    const url = typeof window !== "undefined" ? window.location.href : "";

    logger.error("ui_crash", {
      surface: "admin",
      error: message,
    });

    try {
      const payload = {
        type: "react_error_boundary",
        app: "admin",
        url,
        user_agent: typeof navigator !== "undefined" ? navigator.userAgent : undefined,
        message,
        stack: [stack, componentStack].filter(Boolean).join("\n"),
        last_request_id: last?.requestId || null,
        last_correlation_id: last?.correlationId || null,
        last_trace_id: last?.traceId || null,
        at_utc: new Date().toISOString(),
      };
      const body = JSON.stringify(payload);
      if (typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function") {
        navigator.sendBeacon("/api/v1/telemetry/client-error", new Blob([body], { type: "application/json" }));
      } else if (typeof fetch === "function") {
        fetch("/api/v1/telemetry/client-error", {
          method: "POST",
          headers: { "content-type": "application/json" },
          body,
          credentials: "include",
          keepalive: true,
        }).catch(() => {});
      }
    } catch {
      // ignore
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-4 font-sans">
          <h1>Admin error</h1>
          <p>Refresh the page. If it keeps happening, capture a screenshot and the time.</p>
        </div>
      );
    }
    return this.props.children;
  }
}
